module.exports = __webpack_public_path__ + "images/assets/a556c861059666f33ad145fac5410daa.svg";